module.exports = __webpack_public_path__ + "img/Graph_icons_Adverse Tag.f3a1a0ee.svg";